/* ========================================================================
   WIKI ENGINE - NOOTRÓPICOS PERÚ (Nav Completa + AutoCategorización)
   ======================================================================== */
document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.getElementById('wiki-search-input');
  const categoryTabs = document.querySelectorAll('.wiki-tab');
  const objectiveChips = document.querySelectorAll('.wiki-chip');
  const resultsGrid = document.getElementById('wiki-results-grid');
  const countDisplay = document.getElementById('wiki-count');
  
  const modal = document.getElementById('wiki-modal');
  const modalCloseBtn = document.getElementById('wiki-modal-close-btn');
  const footerCloseBtn = document.getElementById('wiki-footer-close-btn');
  const modalScrollArea = document.getElementById('wiki-modal-scroll');
  const modalTitle = document.getElementById('wiki-modal-title');
  const modalSubtitle = document.getElementById('wiki-modal-subtitle');
  const modalDesc = document.getElementById('wiki-modal-desc');
  const modalBuyBtn = document.getElementById('wiki-modal-buy-btn');
  const modalBadges = document.getElementById('wiki-modal-badges');
  
  const btnPrev = document.getElementById('wiki-prev-btn');
  const btnNext = document.getElementById('wiki-next-btn');

  let state = { searchTerm: "", category: "all", activeChips: [] };
  window.wikiDatabase = [];
  window.currentFilteredList = [];
  let currentDrawerIndex = -1;

  function processProduct(item) {
    if (!item) return null;
    let name = item.title_raw || "Producto";
    let subtitle = "";

    if (name.includes('►')) { let parts = name.split('►'); name = parts[0].trim(); }
    let match = name.match(/\(([^)]+)\)/);
    if (match) { subtitle = match[1]; name = name.replace(/\([^)]+\)/g, '').trim(); }

    let itemTags = item.tags || "";
    let itemShortDesc = item.short_desc || "";
    let textToAnalyze = (itemTags + " " + itemShortDesc + " " + name).toLowerCase();
    
    // AUTO-CATEGORIZADOR INTELIGENTE
    let cat = "Nootrópicos";
    if (textToAnalyze.includes('péptid') || textToAnalyze.includes('peptid') || textToAnalyze.includes('bpc') || textToAnalyze.includes('cjc') || textToAnalyze.includes('tb-500') || textToAnalyze.includes('ipamorelin')) {
        cat = "Péptidos";
    } else if (textToAnalyze.includes('fórmula') || textToAnalyze.includes('complex') || textToAnalyze.includes('stack')) {
        cat = "Fórmulas Especializadas";
    } else if (textToAnalyze.includes('suplemento') || textToAnalyze.includes('vitamina') || textToAnalyze.includes('mineral') || textToAnalyze.includes('magnesio')) {
        cat = "Suplementos";
    }
    
    let filterChips = [];
    const rules = {
      'Hormonal': ['hormon', 'menopausia', 'estrógeno', 'testosterona', 'dhea'],
      'Cognitivo': ['cognitiv', 'memoria', 'enfoque', 'cerebro', 'neuronal', 'atención'],
      'Energía': ['energ', 'fatiga', 'vitalidad', 'mitocondri', 'atp'],
      'Inmune': ['inmune', 'defensa', 'anticuerpos', 'virus'],
      'Recuperación': ['recuperación', 'múscul', 'lesión', 'regeneraci'],
      'Sueño': ['sueño', 'insomnio', 'dormir', 'melatonina'],
      'Antiaging': ['antiaging', 'longevidad', 'envejecimiento', 'colágeno'],
      'Digestión': ['digestiv', 'intestin', 'microbioma', 'probiótico', 'flora'],
      'Metabolismo': ['metaból', 'azúcar', 'insulina', 'peso', 'quema'],
      'Hígado': ['hígado', 'hepátic', 'detox', 'toxina'],
      'Articulaciones': ['articular', 'hueso', 'ósea', 'artritis', 'cartílago']
    };

    for (const [chip, keywords] of Object.entries(rules)) {
      if (keywords.some(kw => textToAnalyze.includes(kw))) filterChips.push(chip);
    }

    return {
      handle: item.handle, name: name, objective: subtitle, category: cat,
      short_desc: itemShortDesc, url: item.url, filterChips: filterChips,
      searchString: `${name} ${subtitle} ${cat} ${itemTags} ${itemShortDesc}`.toLowerCase()
    };
  }

  function renderResults() {
    if (!window.wikiDatabase || window.wikiDatabase.length === 0) return;
    
    window.currentFilteredList = window.wikiDatabase.filter(product => {
      const matchS = product.searchString.includes(state.searchTerm.toLowerCase());
      const matchC = state.category === "all" || product.category === state.category;
      const matchCh = state.activeChips.length === 0 || state.activeChips.every(chip => product.filterChips.includes(chip));
      return matchS && matchC && matchCh;
    });

    countDisplay.innerHTML = window.currentFilteredList.length;

    if (window.currentFilteredList.length === 0) {
      resultsGrid.innerHTML = `<p style="grid-column: 1/-1; text-align:center; color:#9e9ea5;">No se encontraron compuestos. Limpia los filtros o el buscador.</p>`;
      return;
    }

    resultsGrid.innerHTML = window.currentFilteredList.map(product => {
      const badges = product.filterChips.map(c => `<span class="wiki-card-badge">${c}</span>`).join('');
      return `
        <div class="wiki-card" data-handle="${product.handle}">
          <h3 class="wiki-card-title">${product.name}</h3>
          ${product.objective ? `<p class="wiki-card-subtitle">${product.objective}</p>` : ''}
          <div class="wiki-card-badges">${badges}</div>
          <p class="wiki-card-desc">${product.short_desc}</p>
          <div class="wiki-card-btn">Estudiar Compuesto</div>
        </div>`;
    }).join('');
  }

  // EXTRACCIÓN Y PAGINACIÓN
  try {
    const dataNode = document.getElementById('wiki-product-data');
    if (dataNode) {
      const parsedData = JSON.parse(dataNode.textContent.trim());
      window.wikiDatabase = parsedData.items.filter(item => item !== null).map(processProduct);
      renderResults();

      if (parsedData.totalPages > 1) {
        countDisplay.innerHTML += " <span style='font-size:12px; color:var(--wiki-accent);'>(Sincronizando catálogo completo...)</span>";
        let promises = [];
        for (let i = 2; i <= parsedData.totalPages; i++) {
          promises.push(
            fetch(window.location.pathname + '?page=' + i)
              .then(res => res.text())
              .then(html => {
                 let doc = new DOMParser().parseFromString(html, 'text/html');
                 let node = doc.getElementById('wiki-product-data');
                 if (node) {
                    let nextData = JSON.parse(node.textContent).items.map(processProduct);
                    window.wikiDatabase = window.wikiDatabase.concat(nextData);
                 }
              })
          );
        }
        Promise.all(promises).then(() => renderResults());
      }
    }
  } catch (err) { console.error("Wiki Error:", err); }

  searchInput.addEventListener('input', (e) => { state.searchTerm = e.target.value; renderResults(); });
  categoryTabs.forEach(t => t.addEventListener('click', () => {
      categoryTabs.forEach(tab => tab.classList.remove('active')); t.classList.add('active');
      state.category = t.getAttribute('data-category'); renderResults();
  }));
  objectiveChips.forEach(c => c.addEventListener('click', () => {
      const obj = c.getAttribute('data-objective'); c.classList.toggle('active');
      if (c.classList.contains('active')) state.activeChips.push(obj);
      else state.activeChips = state.activeChips.filter(i => i !== obj);
      renderResults();
  }));

  // ABRIR PANEL LATERAL (Navegación Intracatálogo)
  function openDrawer(index) {
    if (index < 0 || index >= window.currentFilteredList.length) return;
    currentDrawerIndex = index;
    const product = window.currentFilteredList[currentDrawerIndex];
    
    modalTitle.textContent = product.name; 
    modalSubtitle.textContent = product.objective || product.category;
    modalBuyBtn.href = product.url;
    modalBadges.innerHTML = product.filterChips.map(chip => `<span class="wiki-card-badge">${chip}</span>`).join('');
    
    // Activa/Desactiva botones Siguiente y Anterior
    btnPrev.disabled = currentDrawerIndex === 0;
    btnNext.disabled = currentDrawerIndex === window.currentFilteredList.length - 1;

    modalDesc.innerHTML = `<p style="color: var(--wiki-accent); font-size:14px;">↻ Consultando evidencia clínica...</p>`;
    modal.classList.add('active'); document.body.style.overflow = 'hidden'; modalScrollArea.scrollTop = 0; 

    // Lazy Loading (Extracción AJAX de la descripción profunda)
    fetch(`/products/${product.handle}.js`)
      .then(r => r.json())
      .then(data => {
          if(data.description) modalDesc.innerHTML = data.description;
          else modalDesc.innerHTML = "<p>No hay información clínica adicional en la ficha.</p>";
      }).catch(() => { modalDesc.innerHTML = "<p>Error de carga. Ve al producto para más detalles.</p>"; });
  }

  resultsGrid.addEventListener('click', (e) => {
    const card = e.target.closest('.wiki-card'); if (!card) return;
    const handle = card.getAttribute('data-handle');
    const index = window.currentFilteredList.findIndex(p => p.handle === handle);
    openDrawer(index);
  });

  // BOTONES DE NAVEGACIÓN INFERIOR (Footer App Bar)
  btnPrev.addEventListener('click', () => openDrawer(currentDrawerIndex - 1));
  btnNext.addEventListener('click', () => openDrawer(currentDrawerIndex + 1));

  // CERRAR EL PANEL (Múltiples vías)
  const closeDrawer = () => { modal.classList.remove('active'); document.body.style.overflow = ''; };
  modalCloseBtn.addEventListener('click', closeDrawer);
  footerCloseBtn.addEventListener('click', closeDrawer);
  modal.addEventListener('click', (e) => { if (e.target === modal) closeDrawer(); });
});